.root {
  display: var(--haus-conditionalTemplate__root__display, contents);
}
